/* eslint-disable sonarjs/no-nested-template-literals */
import { FileType } from "@prisma/client";
import { saveAs } from "file-saver";
import environment from "../environments/environment";
import { useIsMobile } from "@ui/utils";
import { useCallback } from "react";

// The media CloudFront sends no CORS headers: anything drawn on a canvas reads the bucket instead.
export const getMediaBucketUrl = (key: string) =>
  `https://${environment.NEXT_PUBLIC_MEDIAS_BUCKET_NAME}.s3.eu-west-3.amazonaws.com/${key}`;

export const getFileUrl = (
  key?: string,
  fileType?: FileType,
  width?: number
) => {
  if (!key || !fileType) return "";
  if (fileType === "media") {
    if (environment.NEXT_MEDIAS_CLOUDFRONT_BASE_URL) {
      return `${environment.NEXT_MEDIAS_CLOUDFRONT_BASE_URL}/${key}?format=webp${width ? `&width=${width}` : ""}`;
    }

    return getMediaBucketUrl(key);
  } else if (fileType === "ticket") {
    return `https://${environment.NEXT_PUBLIC_TICKETS_BUCKET_NAME}.s3.eu-west-3.amazonaws.com/${key}`;
  }
  return `https://${environment.NEXT_PUBLIC_DOCUMENTS_BUCKET_NAME}.s3.eu-west-3.amazonaws.com/${key}`;
};

export const useFileUrlGetter = () => {
  const isMobile = useIsMobile();

  const getter = useCallback((key?: string, fileType?: FileType, width?: number) => {
    if (width && width < 768) {
      return getFileUrl(key, fileType, width);
    }

    if (isMobile) {
      return getFileUrl(key, fileType, 768);
    }

    return getFileUrl(key, fileType, width);

  }, [isMobile]);

  return { getFileUrl: getter };
}

export async function downloadFile(url: string, filename: string) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    saveAs(blob, filename);
  } catch (error) {
    console.error("Erreur lors du téléchargement:", error);
  }
}
